import { error } from 'utils/logger'

export const throwOnError = (request) => {
  var err = new Error()
  return new Promise((resolve, reject) => {
    request.then((response) =>  {
      if (response.ok) {
        resolve(response)
      } else {
        if (response.status === 500) {
          error('captured request error from response.', response)
        }

        // throw error on any not ok HTTP status. By default, the fetch library
        // treats all error HTTP status codes as normal responses.
        //
        // https://github.com/github/fetch#handling-http-error-statuses
        // var err = new Error(response.statusText)
        err.message = response.statusText
        err.response = response.clone()

        if (err.response.json) {
          console.log("throwOnError received response, unpack json()")
          err.response.json()
            .then(rendered => {
              console.log("> throwOnError json() rendered", rendered)
              err.obj = rendered
              reject(err)
            })
            .catch(error => error.message.startsWith("JSON.parse:")
              ? reject(err)
              : reject(error)
            )
        } else {
          console.log("throwOnError received response, reject ")
          reject(err)
        }
      }
    })
  })
}

export const collectJSON = (request, includeHeaders=false) => {
  let headers = {}

  return request.
    then(response => {
      let json

      try {
        json = response.json()
      } catch (ex) {
        if (response.status >= 200 && response.status < 300) {
          json = null
        } else {
          error('parsing JSON failed:', ex.message)
        }
      }

      // NOTE: Headers looks like a plain Object, but requires .get to access values
      headers = response.headers

      return json
    }).then(json => {
      if (typeof json !== 'undefined' && json !== 'undefined') {
        return includeHeaders ? { body: json, headers } : json
      }

      throw `ERROR, failed to parse request, received JSON is undefined`
    })
}

export const unpackError = (err) => {
  if (err.response && err.response.json) {
    return new Promise(resolve => {
      err.response.json().
        then(json => {
          if (json.error) {
            resolve(json.error)
          } else if (json.message) {
            resolve(json.message)
          }
        }).
        catch(() => {
          resolve(`Error: HTTP ${err.status}`)
        })
    })
  } else {
    return new Promise(resolve => {
      resolve(`Error: HTTP ${err.status}`)
    })
  }
}
